import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap5';

import routes from 'app/routes';
import useLoadTopics from 'components/new_ui/Hooks/useLoadTopics';
import Topics from 'components/ProgramBuilder/Topics';
import { getItems } from 'components/ProgramBuilder/Storage';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import StepTab from 'components/new_ui/Tabs/StepTab';
import Alert from 'components/new_ui/Alerts/alert';

export default function ChooseTopics({ enterpriseId }) {
  const { topics, categories } = useLoadTopics({ enterprise_id: enterpriseId });

  const [workTopics, setWorkTopics] = useState(null);

  const navigate = useNavigate();

  const { state } = useLocation();
  const { data } = state || {};

  useEffect(() => {
    if (topics.length === 0) {
      return;
    }
    const cacheSelectedTopics = getItems()
      || (state && state.template && state.template.attributes.steps.map((step) => step.topic.id)) || [];

    setWorkTopics(topics
      .filter((item) => item.attributes.special_type !== 'employee_choice')
      .map((topic) => ({
        ...topic,
        checked: cacheSelectedTopics.includes(topic.id),
      })));
  }, [topics]);

  const onContinue = () => {
    if (workTopics.filter((item) => item.checked).length === 0) {
      Alert({
        title: 'Build Program',
        text: 'Please select one or more topics before moving to the next step.',
        confirmButtonText: 'Close',
      });
    } else {
      navigate(
        routes.managers.templates.orderTopics,
        {
          state: {
            selectedTopics: workTopics.filter((item) => item.checked),
            data,
            template: state.template,
          },
        },
      );
    }
  };

  return (
    <>
      <StepTab total={3} current={1} />

      <div className="content">
        <section>
          <h1 className="mb-3">Select Topics</h1>

          <p>
            Our Wellbeing topics will first help you identify work-related
            triggers impacting your mental and emotional health.
            Then you’ll learn new skills and habits so you can feel good and function well.
            Our Productivity topics will help you develop new behaviors instrumental in
            achieving desired levels of performance.
          </p>

          <p>Click below to select your topics!</p>
        </section>

        {(workTopics === null || categories.length === 0) && (
        <section>
          <LoadingPlaceholder text="Loading topics..." />
        </section>
        )}

        {workTopics && categories && categories.length > 0 && (
        <>
          <Topics
            topics={workTopics}
            categories={categories}
            onChange={(result) => {
              setWorkTopics(result);
            }}
          />

          <footer className="d-flex justify-content-between">
            <Link
              to={routes.managers.templates.index}
              className="btn btn-outline-primary"
            >
              Previous
            </Link>

            <Button
              onClick={onContinue}
            >
              Next
            </Button>
          </footer>
        </>
        )}
      </div>
    </>
  );
}

ChooseTopics.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
